const stylesFilterResultsLimit = 20;

export { stylesFilterResultsLimit };
